module.exports = __webpack_public_path__ + "img/43.0dc37d1c.jpg";